import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const CurrencyNoteMoney = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#clip0_1689_158)" fill={color}>
      <Path d="M20.53 9.65c.24 0 .43.19.43.43v7.84c0 .24-.19.43-.43.43H5.54c-.24 0-.43-.19-.43-.43v-7.84c0-.24.19-.43.43-.43h14.98m0-1.4H5.54c-1.01 0-1.83.82-1.83 1.83v7.84c0 1.01.82 1.83 1.83 1.83h14.98c1.01 0 1.83-.82 1.83-1.83v-7.84c0-1.01-.82-1.83-1.83-1.83z" />
      <Path d="M17.87 10.93c0-.08.01-.16.03-.24H8.38c.02.08.03.16.03.24 0 .77-.77 1.4-1.71 1.4-.07 0-.14-.01-.21-.02v3.37c.07 0 .14-.02.21-.02.95 0 1.71.63 1.71 1.4 0 .08-.01.16-.03.24h9.52a.986.986 0 01-.03-.24c0-.77.77-1.4 1.71-1.4v-3.34c-.95 0-1.71-.63-1.71-1.4v.01zm-8.49 3.69c-.34 0-.62-.28-.62-.62 0-.34.28-.62.62-.62.34 0 .62.28.62.62 0 .34-.28.62-.62.62zm3.65.98c-.88 0-1.6-.72-1.6-1.6 0-.88.72-1.6 1.6-1.6.88 0 1.6.72 1.6 1.6 0 .88-.72 1.6-1.6 1.6zm3.62-.92c-.34 0-.62-.28-.62-.62 0-.34.28-.62.62-.62.34 0 .62.28.62.62 0 .34-.28.62-.62.62z" />
      <Path d="M3.51 15.35h-.33c-.24 0-.43-.19-.43-.43V7.08c0-.24.19-.43.43-.43h14.98c.24 0 .43.19.43.43V8h1.4v-.92c0-1.01-.82-1.83-1.83-1.83H3.19c-1.01 0-1.83.82-1.83 1.83v7.84c0 1.01.82 1.83 1.83 1.83h.33v-1.4h-.01z" />
    </G>
    <Defs>
      <ClipPath id="clip0_1689_158">
        <Path fill="#fff" d="M0 0H24V24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CurrencyNoteMoney
